import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/blog/")({
  head: () => buildRouteHead("/blog/", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/blog", replace: true });
  },
});
